export const    PLANS = {
  BASIC: { title: "Basic Plan", price: 249 },
  KING: { title: "Plus Plan", price: 499 },
  PRO: { title: "PRO Plan", price: 999 },
};  